var map = {
	"./player_head_1.jpg": "zvt5",
	"./player_head_10.jpg": "Dua0",
	"./player_head_11.jpg": "JZl3",
	"./player_head_12.jpg": "fF4b",
	"./player_head_13.jpg": "fe5z",
	"./player_head_14.jpg": "Qv2N",
	"./player_head_15.jpg": "325i",
	"./player_head_16.jpg": "NGv5",
	"./player_head_17.jpg": "NfXh",
	"./player_head_18.jpg": "6/u/",
	"./player_head_2.jpg": "sLDl",
	"./player_head_3.jpg": "ELur",
	"./player_head_4.jpg": "a5NT",
	"./player_head_5.jpg": "3D73",
	"./player_head_6.jpg": "V44T",
	"./player_head_7.jpg": "WlGo",
	"./player_head_8.jpg": "0i3w",
	"./player_head_9.jpg": "TUfM",
	"./player_head_none.jpg": "9fc8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RppO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user ^\.\/player_head_.*$
// module id = RppO
// module chunks = 1